module.exports = __webpack_public_path__ + "static/img/logo_h5.a149236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/logo_h5.png
// module id = 0rRM
// module chunks = 34